import { render, staticRenderFns } from "./BestCard.vue?vue&type=template&id=709786b1&scoped=true"
import script from "./BestCard.vue?vue&type=script&lang=js"
export * from "./BestCard.vue?vue&type=script&lang=js"
import style0 from "./BestCard.vue?vue&type=style&index=0&id=709786b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709786b1",
  null
  
)

export default component.exports